import React, { Component, Fragment } from 'react';
import axios from 'components/AppRequest';
import CommunicateBox from 'components/components/common/CommunicateBox';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import VerificationInput from 'react-verification-input';
import mergeErrors from 'components/helpers/mergeErrors';
import { connect } from 'react-redux';
import { updateCustomerPhone } from 'components/actions/authActions'
import {
  createSuccessNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';

class PhoneSmsVerificationCode extends Component {
  state = {
    isLoading: false,
  }

  transNotify = (key) => {
    return TransHelper.translate(this.props.locale, 'content.notifications.phoneSmsVerification.' + key);
  }

  createAccountRequest = () => {
    this.setState(
      { isLoading: true },
      () => {
        if (this.validInput.state.tan.length === 4) {
          const { phone, phoneCountry } = this.props;
          var wholePhone = phoneCountry.label + phone;
          var params = {
            verification_code: this.validInput.state.tan,
            phone: wholePhone,
          };

          axios.post('/pwa/customer/change-phone-number', params)
            .then(response => {
              this.props.updateCustomerPhone(wholePhone);
              this.setState({ isLoading: false });
              this.props.changePhoneNumber('');
              this.props.changePhoneCountry({ value: 'norway', label: '+47' });
              this.props.createSuccessNotification({
                message: this.transNotify('success')
              });
              this.props.toggleView();
            })
            .catch(err => {
              console.log("err", err);
              var mergedErrors = mergeErrors(err.response.data.errors);
              this.props.createErrorNotification({
                title: this.transNotify('error'),
                message: mergedErrors
              });
              this.setState({ isLoading: false });
            });
        } else {
          this.setState({ isLoading: false });
          this.props.createErrorNotification({
            title: this.transNotify('error'),
            message: this.transNotify('errorMessage')
          });
        }
      });
  }

  submitForm = (e) => {
    e.preventDefault();
    this.createAccountRequest();
  }

  handleToggleClick = (e) => {
    e.preventDefault();
    this.props.toggleView();
  }

  render() {
    const { isLoading } = this.state;
    const { phoneCountry, phone } = this.props;

    return (
      <form onSubmit={this.submitForm}>
        <fieldset>
          <legend className="visuallyhidden">Phone Number Form</legend>
          <p className="text-center" style={{ marginBottom: '12px' }}>
            <T variables={{
              "phone_label": phoneCountry.label,
              "phone_number": phone
            }}>content.userData.changePhoneForm.sendCodeInfo</T>
          </p>

          <VerificationInput
            autoFocus={true}
            debug={false}
            length={4}
            placeholder=" "
            removeDefaultStyles
            characters={{
              className: 'characters',
            }}
            character={{
              className: 'character',
              classNameInactive: 'character--disabled',
              classNameSelected: 'character--selected',
              type: 'number-pad',
              inputMode: 'numeric',
            }}
            validChars="0-9"
            inputField={{
              inputMode: 'numeric',
              type: 'number-pad',
            }}
            ref={ref => this.validInput = ref}
          />
          <p className="text-right text-small mb-30">
            <a
              href=""
              onClick={this.handleToggleClick}
              title="Back"
            >
              <T>content.userData.changePhoneForm.backToPhone</T>
            </a>
          </p>

          {isLoading
            ?
            <LoadingSpinner className="button button--expand" />
            :
            <button className="button button--expand">
              <T>content.userData.changePhoneForm.done</T>
            </button>
          }
        </fieldset>
      </form>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale
  }
}

export default connect(
  mapStateToProps,
  { updateCustomerPhone, createSuccessNotification, createErrorNotification }
)(PhoneSmsVerificationCode);
